import React from 'react'

const SectionHead = ({ head, subhead, children }) => (
  <div className="section-head">
    <h1 className="last">{head}</h1>
    {subhead || children ? (
      <p className="subhead">{subhead || children}</p>
    ) : null}
  </div>
)
export default SectionHead



// WEBPACK FOOTER //
// ./components/layout/SectionHead.js